/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ISiloFactoryV2,
  ISiloFactoryV2Interface,
} from "../ISiloFactoryV2";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "version",
        type: "uint128",
      },
    ],
    name: "NewSiloCreated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_version",
        type: "uint128",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "createSilo",
    outputs: [
      {
        internalType: "address",
        name: "silo",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "siloFactoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class ISiloFactoryV2__factory {
  static readonly abi = _abi;
  static createInterface(): ISiloFactoryV2Interface {
    return new utils.Interface(_abi) as ISiloFactoryV2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISiloFactoryV2 {
    return new Contract(address, _abi, signerOrProvider) as ISiloFactoryV2;
  }
}
